import {
    config,
    mockResolveApiCall,
    requestOptions,
    requestTypes,
    sendRequest
} from "../../../Utilities/Api";
import {studentData} from "../studentMockData";

//************************************************** STANDARD API SERVER CALLS ****************************************

class ServerStudentApprovalApi {
    static getStudentApprovalRequests(studentSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(studentSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}students/patrons?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }
    static approveStudents(approveAndSearchStudentsModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `students/status`,
                requestTypes.PUT,
                JSON.stringify(approveAndSearchStudentsModel),
            ),
        );
    }
}

//************************************************** MOCK API SERVER CALLS ****************************************

class MockStudentApprovalApi {
    static getStudentApprovalRequests() {

        return mockResolveApiCall( studentData, "");
    }

    static approveStudents() {
        return mockResolveApiCall( studentData, "");
    }

    static getOrganizations() {
        return mockResolveApiCall([], "");
    }
}

export const studentApprovalApi = config.environment.MODE === config.modes.SERVER ? ServerStudentApprovalApi : MockStudentApprovalApi;
